<template>
  <div style="width: 1400px; height: 700px">
    <model-gltf src="static/models/test.glb"></model-gltf>
  </div>
</template>

<script>
import { ModelGltf } from "vue-3d-model";
export default {
  components: { ModelGltf },
};
</script>



// WEBPACK FOOTER //
// src/components/test/Test3D.vue